module.exports = __webpack_public_path__ + "static/media/border-center-h.238a696d.svg";